import React from "react";
import T from "prop-types";

export function Button({
  buttonClass = "btn-info",
  children,
  onClick = () => {},
  spanClass = "input-group-btn"
}) {
  return (
    <span className={spanClass}>
      <button className={`btn ${buttonClass}`} onClick={onClick}>
        {children}
      </button>
    </span>
  );
}

Button.propTypes = {
  buttonClass: T.string,
  children: T.oneOfType([T.node, T.arrayOf(T.node)]),
  onClick: T.func.isRequired,
  spanClass: T.string
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Button/Button.jsx